(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.header.classList.toggle('scrolled-past-header', this.currentScrollTop > 1);
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      // in drawer click # close drawer:
      this.initHashLinks();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

     // ---  FUNCTION: For click Anchor links (#) handle ---
    initHashLinks() {
      // Header and Drawer links which one contain '#'
      const hashLinks = this.header.querySelectorAll('a[href*="#"]');
      
      hashLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const href = link.getAttribute('href');
          // Trigger when link matched actual ID  (like '#about' ya '/#contact')
          if (href && href !== '#' && href.includes('#')) {
            this.closeAllDrawers();
          }
        });
      });
    }

    // --- FUNCTION for close Drawer aur Modals close ---
    closeAllDrawers() {
      // 1. Close Menu Disclosures 
      this.closeMenuDisclosure();

      // 2. Close Search Modal
      this.closeSearchModal();

      // 3. Close Shopify Header Drawer / Menu Drawer 
      const drawers = this.header.querySelectorAll('header-drawer, menu-drawer');
      drawers.forEach((drawer) => {
        if (typeof drawer.closeMenuDrawer === 'function') {
          const drawerSummary = drawer.querySelector(':scope > details > summary') || drawer.querySelector('summary');
          drawer.closeMenuDrawer(new Event('click'), drawerSummary);
        } else {
          const details = drawer.querySelector('details');
          if (details) {
            details.removeAttribute('open');
          }
        }
      });

      // 4. For close details tag is open
      this.header.querySelectorAll('details[open]').forEach((details) => {
        details.removeAttribute('open');
      });
      this.header.classList.remove('menu-open');

      // 5. Remove overeflow
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden-tablet');
      document.documentElement.classList.remove('overflow-hidden');
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // The transparent/reverted header is only valid at the very top of the page.
      this.header.classList.toggle('scrolled-past-header', scrollTop > 10);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (scrollTop > this.currentScrollTop && scrollTop > 10) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      // } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      } else if (scrollTop < this.currentScrollTop && scrollTop > 10) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      // } else if (scrollTop <= this.headerBounds.top) {
      } else if (scrollTop <= 1) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
